const css = `.page-template-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-4);
}
.page-template-header .p-breadcrumb {
  width: 100%;
  overflow: visible;
  display: flex;
  border: unset;
  background-color: transparent;
}
.page-template-header .p-breadcrumb .p-breadcrumb-list {
  gap: var(--space-0-5);
}
.page-template-header .p-breadcrumb .p-breadcrumb-home {
  padding-right: var(--space-2);
}
.page-template-header .p-breadcrumb .p-breadcrumb-home .p-menuitem-text {
  color: var(--text);
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-medium);
}
.page-template-header .p-breadcrumb .p-menuitem {
  opacity: 1;
  display: flex;
  font-weight: var(--font-weight-regular);
  border-radius: 8px;
}
.page-template-header .p-breadcrumb .p-menuitem .p-button-label {
  transition: color 0s;
  color: var(--text-muted);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-base);
  text-decoration: none;
  padding-left: var(--space-2);
  padding-right: var(--space-2);
}
.page-template-header .p-breadcrumb .p-menuitem:not(.p-disabled):hover {
  background-color: var(--accent-subtle);
}
.page-template-header .p-breadcrumb .p-menuitem:not(.p-disabled):hover .p-button-label {
  color: var(--accent);
}
.page-template-header .p-breadcrumb .p-menuitem.p-disabled .p-button-label {
  color: var(--text);
  font-weight: var(--font-weight-semibold);
}
.page-template-header .p-breadcrumb svg.p-icon {
  width: 14px;
  height: 14px;
}

.page-template-content {
  width: 100%;
  flex: 1;
  flex-direction: column;
  display: flex;
  gap: var(--space-4);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
